export default __webpack_public_path__ + "static/media/anniversary3.d868842c.webp";